<template>
  <div id="Footer">
    <div class="footer_content content_1040">
      <!--底部内容-->
      <div class="content">
        <!--左侧-->
        <div class="left">
          <!--客服电话-->
          <div class="company_tel_phone">
            <div class="title">客服电话:</div>
            <div class="bold_text">{{ telNumber }}</div>
          </div>
          <!--Email-->
          <div class="company_details">
            <div class="email">
              <div class="title">E-mail:</div>
              <div class="bold_text">support@texperts.com</div>
            </div>
            <div class="address">
              <div class="title">公司地址:</div>
              <div class="bold_text">北京市大兴区广茂大街20号钛媒体创新园</div>
            </div>
          </div>
        </div>
        <!--右侧-->
        <div class="right">
          <!--客户端下载-->
          <div class="item app">
            <img src="~@/assets/logo/app.jpg" alt="" />
            <p class="title">钛刻专家APP</p>
            <p class="title">顶尖专家1对1服务</p>
            <p class="title">扫码下载钛刻专家APP</p>
          </div>
          <!--小程序-->
          <!--<div class="item wx">-->
          <!--<img src="https://www.tmtpost.com/public/css/img/app_qrcode.png" alt="">-->
          <!--<p class="title">小程序</p>-->
          <!--</div>-->
        </div>
      </div>
      <!--版权-->
      <div class="copyright">
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"
          >© 2019 TMTEXP {{ record }}</a
        >
        <div style="margin-left: 40px">
          <a
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011502003806"
            style="display:flex;align-items: center;justify-content: center;"
          >
            <img
              src="./../assets/imgs/bah.png"
              style="width: 20px;height: 20px;"
            />
            <p
              style="height:20px;font-size:12px;font-weight:400;color:rgb(51,51,51);line-height:20px;margin: 0px 0px 0px 5px;"
            >
              京公网安备 11011502003806号
            </p>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let _self;
export default {
  name: "Footer",
  data() {
    return {
      telNumber: "", //客服电话
      record: "", //备案号
    };
  },
  created() {
    _self = this;
    //判断是正式还是测试服
    if(process.env.NODE_ENV == 'production'){
      _self.record = '京ICP备13040123号-13';
    }else{
      _self.record = '京ICP备13040123号-9';

    }
  },
  mounted() {
    _self.$tkApi
      .get("/utility/copywriting", {
        params: {
          key: "customer_service_phone;"
        }
      })
      .then(res => {
        let resData = res.data;
        if (resData.result === "ok") {
          _self.telNumber = resData.data[0].main;
        }
      })
      .catch(err => {
        _self.$log(err);
      });
  }
};
</script>

<style scoped lang="scss">
#Footer {
  z-index: 999;
  height: 390px;
  background: #fff;
  border-top: 1px solid #e5e8f0;
  .footer_content {
    height: 100%;
    padding: 60px 0;
    /*内容部分*/
    .content {
      display: flex;
      justify-content: space-between;
      padding-bottom: 40px;
      /*左侧公司详情*/
      .left {
        display: flex;
        /*公司电话*/
        .company_tel_phone {
          margin-right: 120px;
        }
        /*公司详情*/
        .company_details {
          .email {
            margin-bottom: 30px;
          }
        }
        /*标题*/
        .title {
          font-size: 14px;
          color: rgb(98, 105, 123);
          line-height: 24px;
        }
        /*加粗文字*/
        .bold_text {
          font-size: 16px;
          font-weight: bold;
          color: rgb(51, 51, 51);
          line-height: 36px;
          margin-top: 10px;
        }
      }
      /*右侧二维码部分*/
      .right {
        display: flex;
        .item {
          width: 100%;
          text-align: center;
          img {
            width: 100px;
            height: 100px;
            border: 1px solid #cfd2d7;
          }
          .title {
            text-align: center;
            margin-top: 10px;
            font-size: 12px;
            color: rgb(51, 51, 51);
            line-height: 18px;
          }
        }
        /*APP下载*/
        .app {
          margin-right: 40px;
        }
      }
    }
    /*版权部分*/
    .copyright {
      border-top: 1px solid #e5e8f0;
      text-align: center;
      padding-top: 40px;
      font-size: 12px;
      font-weight: 400;
      color: rgb(51, 51, 51);
      line-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      a {
        color: rgb(51, 51, 51);
        list-style: none;
        text-decoration: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue